import type { CashOutResult, CashOutValueResult } from '@/interface/cashOut';
import { CashOutStatus } from '@/interface/enum';
import type { CashOutResponse, CashOutValueResponse } from '@/interface/pollux';

export function formatCashOut(cashOut: CashOutResponse): CashOutResult {
    return {
        transId: cashOut.transactionId ?? 0,
        resultStatus: CashOutStatus.fromPollux(cashOut.status),
        cashOutValue: cashOut.cashOutValue ?? 0,
    };
}

export function formatCashOutValue(cashOutValue: CashOutValueResponse): CashOutValueResult {
    return {
        transId: cashOutValue.transactionId ?? 0,
        resultStatus: CashOutStatus.fromPollux(cashOutValue.status),
        cashOutValue: cashOutValue.cashOutValue ?? 0,
        isSupportedFullCashOut: cashOutValue.isSupported ?? false,
        isSupportedPartialCashOut: cashOutValue.isSupportedPartialCashOut ?? false,
        minStake: cashOutValue.minStake ?? 0,
    };
}
